import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=31d8d9c4&scoped=true&"
import script from "./Institutions.vue?vue&type=script&lang=js&"
export * from "./Institutions.vue?vue&type=script&lang=js&"
import style0 from "./Institutions.vue?vue&type=style&index=0&id=31d8d9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8d9c4",
  null
  
)

export default component.exports